$(document).on('moreJS:ready', function(){
	'use strict';

	var NEW_REGCODE = '-new-';
	
	var regcode = NEW_REGCODE;

	var radios = ['p_GESCHLECHT'];	
	var $personFieldsetTpl = null; // fieldset template
	var newPersonLfdid = -1000;	// a new persopn get a negative lfdid
	
	var regData = null;
	var formData = null;
	var formTpl = null;
	
	var $agbFs = null;
	
	function initRegCode(){
		var found = false;
		location.search.substr(1).split('&').forEach(function(e){
			if(e.substr(0, 6) === 'regid='){
				regcode = e.replace('regid=', '');

				found = true;		
				return false;
			}
		});
		
		return found;
	}
	
	// function persons handling
	function initPersons(persons){
		
		for(var lfdid in persons){
			initPersonFieldset(lfdid, persons);
		}
	}
	
	function initPersonFieldset(lfdid, persons){
		var $fieldset = $personFieldsetTpl.clone();
		var keySuffix = '_' + lfdid;
		
		$fieldset.attr('id', $fieldset.attr('id') + '_' + lfdid);

		$fieldset.find('[id], [for]').each(function () {
			if ($(this).attr('id')) {
				$(this).attr('id', $(this).attr('id') + keySuffix);
				if ($(this).attr('name')) {
					$(this).attr('name', $(this).attr('name') + keySuffix);
				}
			} else if ($(this).attr('for')) {
				$(this).attr('for', $(this).attr('for') + keySuffix);
			}

		});

		// generate delete button
		if (lfdid < -1000) {
			var $delPerson = $('<button type="button" class="remove_entry">' + $.i81n.text('REMOVE_PERSON') + '</button>');
			$delPerson.on('click', function() {
				$('#fs-ANMTN_' + lfdid).remove();
				delete regData.persons[lfdid];
			});			
			$fieldset.append($delPerson);
		}else if(lfdid > 0){
			// disable inputs by default
			$fieldset.find('[name]').prop('disabled', true);
			
			// add button to enable inputs for editing
			var $editPerson = $('<button type="button" class="edit_entry">' + $.i81n.text('EDIT_FORMDATA') + '</button>')
					.on('click', function(){
						$fieldset.find('[name]').prop('disabled', false);
						$(this).remove();
					});
			$fieldset.append($editPerson);
		}

		// insert fieldset into DOM so we can fill the inputs
		if ($('#fs-AGB').length > 0) {
			$fieldset.insertBefore($('#fs-AGB'));
		} else {
			$fieldset.insertAfter($('#eventregform fieldset').last());
		}

		// insert values into inputs in fieldset
		for (var key in persons[lfdid]) {
			fillInput(key + keySuffix, persons[lfdid][key]);
		}
	}
	
	function fillInput(key, val){
		
		var pos = key.indexOf('_', 3);
		var checkKey = (pos > -1 ? key.substr(0, pos) : key);
		var keySuffix = (pos > -1 ? key.substr(pos) : '');
		
		if (radios.indexOf(checkKey) > -1) {
			$('[name="'+checkKey+keySuffix+'"]').removeAttr('checked');
			$('#'+checkKey+'-'+val+keySuffix).attr('checked', 'checked');

		} else {
			$('#' + key).val(val);
		}
	}
	
	function updatePersons(){
		var changed = false;
		for (var lfdid in regData.persons) {
			if (updatePersonFieldset(lfdid)) {
				changed = true;
			}
		}
		return changed;
	}
	
	function updatePersonFieldset(lfdid) {
		var changed = false;
		for(var key in regData.persons[lfdid]){
			if (updateInput(key, lfdid)) {
				changed = true;
			}
		}
		return changed;
	}
	
	function updateInput(key, lfdid){
		var changed = false;
		
		var inputid = key;
		
		if (lfdid) {
			inputid = key + '_' + lfdid;
		}
		
		var $input = $('#' + inputid);

		if (radios.indexOf(key) > -1) {
			$input = $('[name="'+inputid+'"]:checked');			
		} 
		
		if ($input.length > 0) {
			var inputVal = $input.val();
			//inputVal.trim();
			
			if (lfdid) {
				// update changed status
				regData.persons[lfdid]['changed'] = (regData.persons[lfdid]['changed'] || regData.persons[lfdid][key] !== inputVal);
				changed = regData.persons[lfdid]['changed'];
				regData.persons[lfdid][key] = inputVal;
			} else {
				// no id -> company data (inputs only)
				changed = (regData[key] !== inputVal);
				regData[key] = inputVal;
			} 
		}
		return changed;
	}
	
	function setRequiredFields() {
		
		// remove person registration status 'O' as selectable option
		$('[id^="p_STATUS_"] option[value="O"]')
				.prop('disabled', true)
				.removeAttr('value');
		var $firstMailInput = $('[id^="p_EMAIL_"]').first();
		if ($firstMailInput.siblings('label').find('.required').length === 0) {
			$firstMailInput.siblings('label').prepend('<span class="required">*&nbsp;</span>');
		}
		
		if (regData.persons[1] && regData.persons[1].p_STATUS !== 'O') {
			var $btnAddPerson = $('#eventreg-addperson').detach();
			$('#eventregform fieldset:last-of-type').after($btnAddPerson);
			if($('#fs-AGB').length){
				$('#eventregform').data('agb', $('#fs-AGB').detach());
			}
		} else {
			$('#fs-AGB span.required').parent().siblings('input[type="checkbox"]').prop('required', true);
		}
		
		if(regData.registerby !== null && regData.registerby < (Date.now() / 1000)){
			$('#eventregform [id^="p_"], #eventregform [id^="p_STATUS_"] option')
				.not('[id^="p_STATUS_"], [id^="p_STATUS_"] option[value="S"]')
				.not(':selected')
				.prop('disabled', true);
		
			$('#eventregform .edit_entry').remove();
		}
		
		if(regData.cancelby !== null && regData.cancelby < (Date.now() / 1000)){
			$('#eventregform [id^="p_"]').prop('disabled', true);
			$('#eventregform .edit_entry').remove();
		}
	}
	
	function addPerson() {
		// decrement the new persopn lfdid
		--newPersonLfdid;

		regData.persons[newPersonLfdid] = {
			p_LFDID: newPersonLfdid.toString(),
			p_GESCHLECHT: 'N',
			p_VORNAME: null,
			p_FAMNAME: null,
			p_AKAD: null,
			p_POSTGRADUATE: null,
			p_GEBDAT: null,
			p_TEL: null,
			p_MOBIL: null,
			p_EMAIL: null,
			p_BEM: null,
			p_STATUS: 'O'
		};

		initPersonFieldset(newPersonLfdid, regData.persons);
		
		setRequiredFields();
	}
	
	
	$('.eventregbox').on('click', function(){
		var ajaxurl = '/api/v1/eventreg/';
		var lockCompanyData = false;
		
		// disable tab index and remove focus from the button
		$(this).attr('tabindex', '-1').trigger('blur');
		
		if (regcode !== NEW_REGCODE) {
			ajaxurl += regcode + (formTpl !== null ? '' : '?getform=1');
			lockCompanyData = true;
		} else {
			ajaxurl += 'form/' + $('.eventregbox[data-eventid]').first().attr('data-eventid');
		}

		$.ajax({
			url: ajaxurl,
			type: 'GET',
			dataType: 'json',
			success: function (data) {
				regData = data;
				// add page ID to regData, this is used to build the link for the confirmation mail
				regData.pageid = parseInt($('.eventregbox').attr('data-pageid'));
				
				if (formTpl === null) {
					formTpl = regData.form;
					delete regData.form;
				}

				// generate form 
				var $formTpl = $(formTpl);
				var $lb = $('<div class="lb_regform wrapper" />');
				var $pageHeadline = $('section#main h1, section#main h2, section#main h3').first().clone();
				
				$formTpl.prepend($pageHeadline);
				
				$personFieldsetTpl = $formTpl.find('#fs-ANMTN').detach();

				
				$.loadLightboxJs(function(){
					$lb.lightbox_me_start($formTpl, {
						closeClick: false,
						onLoad: function () {
							$('#eventregform input[type="text"]').first().focus();
						},
						onClose: function () {
							$lb.remove();
							$('#eventregbox').removeAttr('tabindex');
						}
					});

					$formTpl.on('submit', function (e) {
						e.preventDefault();

						if (!$.checkRequiredFormFields()) {
							return false;
						}

						$('.formerr').remove('span.formerr');
						
						// only make the ajax call if data has been changed
						if (formData !== $(this).serialize()) {
							for (var key in regData) {
								if (key === 'persons') {
									updatePersons(regData.persons);
								} else {
									// company values
									updateInput(key);
								}
							}
							
							// clone regData and remove unchanged persons
							var updateData = JSON.parse(JSON.stringify(regData));
							
							for (var lfdid in regData.persons) {
								if (parseInt(lfdid) !== 1 && !regData.persons[lfdid].changed) {
									delete updateData.persons[lfdid];
								}
							}
							
							$.ajax({
								url: '/api/v1/eventreg/' + regcode,
								type: 'POST',
								dataType: 'json',
								data: JSON.stringify(updateData),
								success: function (result) {
									if (result.status === 'ok') {
										// check if the result containing a new regcode
										if (result.regcode) {
											regcode = result.regcode;
										}
										$.showMessiInfo('Information', $.i81n.text('INFO_REGFORMSAVED'), 3000, 'info');
										$lb.find('.close').trigger('click');
										history.replaceState(null, '', location.href + 
												(location.search ? '&' : '?') + 'regid=' + regcode);
									} else if (result.status === 'error'){
										if (result.code === 400) {
											// insert a span containing the error information and
											// set the focus to the first handled element
											var $focusElem = null;
											for (var inputSelector in result.fielderror) {
												$focusElem = ($focusElem || $(inputSelector));
												$(inputSelector).siblings('label').prepend('<span class="formerr">' +
														result.fielderror[inputSelector] + '</span>');
											}
											if ($focusElem) {
												$focusElem.focus();
											}
										}
									} else {
										console.error('Unknown result from POST!', result);
										$.showMessiInfo('Information', $.i81n.text('INFO_REGFORMSAVED'), 3000, 'info');
									}
								},
								error: function (jqXHR, textStatus, errorThrown) {
									console.error(textStatus + ': ' + errorThrown);
								}

							});

						} else {
							$.showMessiInfo('Information', $.i81n.text('INFO_REGFORMSAVED'), 3000, 'info');
							$lb.find('.close').trigger('click');
						}
					});

					// Only allow adding a new person if registration period is still active
					// and if all other persons have valid names and email addresses
					
					// TODO: remove addperson button if unable to click
					if (!regData['registerby'] || (Date.now() / 1000) < regData['registerby']) {
						$formTpl.find('#eventreg-addperson').on('click', function (e) {
							e.preventDefault();

							addPerson();
							
							// add agb fieldset
							if($('#fs-AGB').length === 0){
								$('#d-submit-registration').before($('#eventregform').data('agb'));
							}
							
//							// move new fieldset into view
//							$('#fs-ANMTN_' + newPersonLfdid)[0].scrollIntoView(false);
//							$('#fs-ANMTN_' + newPersonLfdid).find('input[type="text"]').first().focus();
						});
					}else{
						$formTpl.find('#eventreg-addperson').remove();
					}

					// insert data into form
					for(var key in regData){
						if(key === 'persons'){
							initPersons(regData.persons);
						}else{
							// company values
							fillInput(key, regData[key]);
						}
					}
					
					if(lockCompanyData){
						$('#fs-ANM').find('[name]').prop('disabled', true);
						
						var $editData = $('<button type="button" class="edit_entry">' + $.i81n.text('EDIT_FORMDATA') + '</button>')
								.on('click', function () {
									$('#fs-ANM').find('[name]').prop('disabled', false);
									$(this).remove();
								});
						$('#fs-ANM').append($editData);
					}

					setRequiredFields();
					
					formData = $formTpl.serialize();
				});
			},
			error: function (jqXHR, textStatus, errorThrown) {
				// check if code === 500, if yes reurn technical error alert
				console.log(textStatus + ': ' + errorThrown);
			}
		});
	}); 
	
	// abort if no reg code is given
//	if(initRegCode()){
//		$('.eventregbox').trigger('click');
//	}
	initRegCode();
	
});
